import { render } from "./watermark.vue?vue&type=template&id=2d22cfc1&scoped=true"
import script from "./watermark.vue?vue&type=script&lang=js"
export * from "./watermark.vue?vue&type=script&lang=js"

import "./watermark.vue?vue&type=style&index=0&id=2d22cfc1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@https+++registry.npmmirror.com+vue-loader+-+vue-loader-17.4.2.tgz_vue@3.2.13_webpack@5.95.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d22cfc1"]])

export default __exports__